import { Box, Button } from '@mui/material';
import styled from 'styled-components';
import { PaperWrapper } from '../../common/styled';

export const HeaderWrapper = styled(Box)(() => ({
  maxWidth: '95%',
  marginInline: 'auto'
}));

export const SectionContainerWrapper = styled(PaperWrapper)(() => ({
  minHeight: 'auto',
  paddingBlock: '12px',
  paddingInline: '24px'
}));

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  width: '100%',
  '@media (max-width: 900px)': {
    flexDirection: 'column',
    gap: 16
  },
  '@media (max-width: 600px)': {
    flexDirection: 'column',
    gap: 12
  }
}));

export const RoundedButton = styled(Button).attrs((props: any) => ({
  variant: 'contained',
  color: 'primary',
  style: {
    backgroundColor: props.backgroundColor,
    color: props.textColor
  }
}))<{
  backgroundColor?: string;
  textColor?: string;
}>({
  width: '100%',
  maxWidth: '100%',
  borderRadius: '6px !important',
  '@media (min-width:600px)': {
    width: 'auto',
    maxWidth: '200px'
  },
  textWrap: 'nowrap'
});

export const DateWiseConcessionTitleWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const FormWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
}));
